<template>
  <div class="box-detail">
    <div class="box-left">
      <div class="box-left-header-contact" style="height:50px;">
        <div @click="$router.push({ path: '/ServiceTerritories' })" class="goBack">
          <i class="el-icon-arrow-left"></i>
          <span>{{ typeName }}区域</span>
          <i class="el-icon-place"></i>
        </div>
      </div>
      <div class="box-left-content">
        <el-form
          ref="formData"
          :model="formData"
          :rules="rules"
          label-width="110px"
          label-position="left"
          hide-required-asterisk:true
        >
          <el-form-item :label="`${typeName}区域名称`" prop="name">
            <el-input v-model="formData.name" :placeholder="`请输入${typeName}区域名称`"></el-input>
          </el-form-item>
          <el-form-item v-if="tenantId !== '4551453470943235290'" label="国家" prop="country">
            <el-input v-model="formData.country" placeholder="请输入国家"></el-input>
          </el-form-item>
          <el-form-item label="服务类型" prop="serviceType">
            <el-select
              v-model="formData.serviceType"
              multiple-limit="1"
              multiple
              placeholder="请选择服务类型"
            >
              <el-option
                v-for="item in options.serviceType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="省市区街道" prop="area">
            <el-cascader
              v-if="area.show"
              :options="area.options"
              :props="area.props"
              v-model="formData.area"
              collapse-tags
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item v-if="tenantId !== '4551453470943235290'" label="小区" prop="community">
            <el-input v-model="formData.community" placeholder="请输入小区"></el-input>
          </el-form-item>
          <el-form-item v-if="tenantId !== '4551453470943235290'" label="区域编码" prop="exts.code">
            <el-input v-model="formData.exts.code" placeholder="请输入区域编码"></el-input>
          </el-form-item>
          <el-form-item v-if="tenantId !== '4551453470943235290'" label="邮编" prop="postalCode">
            <el-input v-model="formData.postalCode" placeholder="请输入邮编"></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="description">
            <el-input v-model="formData.description" placeholder="请输入描述"></el-input>
          </el-form-item>
          <!-- <template v-for="(extField, idx) in extFields">
            <template v-if="!extField.preset">
              <el-form-item :key="idx" :label="extField.nameDisp">
                <template
                  v-if="
                    extField.type == 'text' ||
                      extField.type == 'textarea' ||
                      extField.type == 'number'
                  "
                >
                  <el-input v-model="formData.exts[extField.name]" :type="extField.type"></el-input>
                </template>
                <template v-if="extField.type == 'radio'">
                  <el-radio-group v-model="formData.exts[extField.name]">
                    <el-radio
                      v-for="item in options[extField.valueOption]"
                      :key="item.value"
                      :label="item.value"
                    >
                      {{ item.label }}
                    </el-radio>
                  </el-radio-group>
                </template>
                <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
                  <el-checkbox-group v-model="formData.exts[extField.name]">
                    <el-checkbox
                      v-for="item in options[extField.valueOption]"
                      :label="item.value"
                      :key="item.value"
                    >
                      {{ item.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                </template>
                <template v-if="extField.type == 'select'">
                  <el-select v-model="formData.exts[extField.name]" placeholder="请选择" clearable>
                    <el-option
                      v-for="item in options[extField.valueOption]"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
                <template v-if="extField.type == 'cascade'">
                  <el-cascader
                    clearable
                    v-model="formData.exts[extField.name]"
                    :options="options[extField.valueOption]"
                    :props="{ checkStrictly: true, label: 'name' }"
                  ></el-cascader>
                </template>
                <template v-if="extField.type == 'time'">
                  <el-time-select
                    v-model="formData.exts[extField.name]"
                    placeholder="选择时间"
                  ></el-time-select>
                </template>
                <template v-if="extField.type == 'date' || extField.type == 'datetime'">
                  <el-date-picker
                    v-model="formData.exts[extField.name]"
                    :type="extField.type"
                    placeholder="选择日期"
                  ></el-date-picker>
                </template>
                <template v-if="extField.type == 'switch'">
                  <el-switch
                    v-model="formData.exts[extField.name]"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-value="1"
                    inactive-value="0"
                  ></el-switch>
                </template>
                <template v-if="extField.type == 'rate'">
                  <el-rate
                    v-model="formData.exts[extField.name]"
                    @change="$forceUpdate()"
                  ></el-rate>
                </template>
              </el-form-item>
              <el-form-item :key="idx" :label="extField.nameDisp">
                <template
                  v-if="
                    extField.type == 'text' ||
                      extField.type == 'textarea' ||
                      extField.type == 'number'
                  "
                >
                  <el-input v-model="formData.exts[extField.name]" :type="extField.type"></el-input>
                </template>
                <template v-if="extField.type == 'radio'">
                  <el-radio-group v-model="formData.exts[extField.name]">
                    <el-radio
                      v-for="item in options[extField.valueOption]"
                      :key="item.value"
                      :label="item.value"
                    >
                      {{ item.label }}
                    </el-radio>
                  </el-radio-group>
                </template>
                <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
                  <el-checkbox-group v-model="formData.exts[extField.name]">
                    <el-checkbox
                      v-for="item in options[extField.valueOption]"
                      :label="item.value"
                      :key="item.value"
                    >
                      {{ item.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                </template>
                <template v-if="extField.type == 'select'">
                  <el-select v-model="formData.exts[extField.name]" placeholder="请选择" clearable>
                    <el-option
                      v-for="item in options[extField.valueOption]"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
                <template v-if="extField.type == 'cascade'">
                  <el-cascader
                    clearable
                    v-model="formData.exts[extField.name]"
                    :options="options[extField.valueOption]"
                    :props="{ checkStrictly: true, label: 'name' }"
                  ></el-cascader>
                </template>
                <template v-if="extField.type == 'time'">
                  <el-time-select
                    v-model="formData.exts[extField.name]"
                    placeholder="选择时间"
                  ></el-time-select>
                </template>
                <template v-if="extField.type == 'date' || extField.type == 'datetime'">
                  <el-date-picker
                    v-model="formData.exts[extField.name]"
                    :type="extField.type"
                    placeholder="选择日期"
                  ></el-date-picker>
                </template>
                <template v-if="extField.type == 'switch'">
                  <el-switch
                    v-model="formData.exts[extField.name]"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-value="1"
                    inactive-value="0"
                  ></el-switch>
                </template>
                <template v-if="extField.type == 'rate'">
                  <el-rate
                    v-model="formData.exts[extField.name]"
                    @change="$forceUpdate()"
                  ></el-rate>
                </template>
              </el-form-item>
            </template>
          </template> -->
        </el-form>
      </div>
      <div class="box-left-footer">
        <el-button type="primary" @click="doSave">提交</el-button>
        <el-button plain @click="getData">取消</el-button>
      </div>
    </div>
    <!-- 动态 笔记 -->
    <div class="box-center">
      <el-tabs v-model="activeTab" class="c-h-1 c-flex c-flex-col">
        <el-tab-pane label="动态" name="log">
          <div class="box-center-tool">
            <div>
              <el-date-picker
                v-model="log.searchDate"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                clearable
                @change="getLog"
                class="search-date"
              ></el-date-picker>
            </div>
            <div>
              <el-input
                placeholder="请输入标题/内容"
                v-model="log.searchValue"
                class="search-input"
                clearable
                @clear="getLog"
                @keyup.enter.native="getLog"
              >
                <el-button slot="append" icon="el-icon-search" @click="getLog"></el-button>
              </el-input>
            </div>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(log, i) in log.fpi.data" :key="i">
              <div class="activity-card-header">
                <span class="c-font-500">
                  <i class="el-icon-monitor c-w-30"></i>
                  {{ log.title }}
                </span>
                <span>{{ log.createTime }}</span>
              </div>
              <div class="activity-card-content">{{ log.content }}</div>
              <div class="activity-card-footer">
                <span>操作人：{{ log.createUserName }}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="笔记" name="notes">
          <div class="box-center-tool">
            <div></div>
            <el-button
              type="primary"
              size="mini"
              @click="
                vqeditor.content = ``;
                openNote = true;
              "
            >
              创建笔记
            </el-button>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(note, i) in noteData" :key="i">
              <div class="activity-card-header">
                <span>
                  <i class="el-icon-edit-outline c-w-30"></i>
                  笔记
                </span>
                <span>{{ note.createTime }}</span>
              </div>
              <div
                class="activity-card-content-node"
                v-html="note.content"
                @click="noteMdShow(note)"
                v-if="!note.openNote"
              ></div>
              <c-editor
                v-else
                class="c-m-15"
                :formData="note"
                :value="'content'"
                ref="editor"
              ></c-editor>
              <div class="activity-card-footer">
                <span>操作人：{{ note.createUserName }}</span>
              </div>
            </div>
          </div>
          <!-- markdown编辑器 -->
          <el-dialog title="笔记" :visible.sync="openNote">
            <c-editor :formData="vqeditor" :value="'content'" ref="editor"></c-editor>
            <div slot="footer">
              <el-button type="primary" @click="saveNote">确 认</el-button>
              <el-button
                @click="
                  openNote = false;
                  vqeditor.content = '';
                "
              >
                取 消
              </el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="属性变更记录" name="history">
          <div
            class="box-center-content"
            v-infinite-scroll="getHistory"
            :infinite-scroll-immediate="true"
          >
            <c-modify
              :historyFpi="historyFpi"
              :fields="extFields"
              :fieldsObj="fieldsObj"
              :options="options"
              ref="modify"
            ></c-modify>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="业务跟踪"
          name="bizStackTraceSA"
          v-if="osg.has('ServiceTerritory,exception')"
        >
          <bizStackTrace :params="{ sid: id }" v-if="id"></bizStackTrace>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="box-right" :class="collapse ? 'box-collapse' : ''">
      <div class="box-right-header">
        <i class="el-icon-d-arrow-left" @click="collapse = false" v-if="collapse"></i>
        <i class="el-icon-d-arrow-right" @click="collapse = true" v-else></i>
      </div>
      <div class="box-right-content" v-show="!collapse">
        <el-collapse v-model="activeNames">
          <el-collapse-item name="1">
            <template slot="title">
              <span>{{ typeName }}资源</span>
              <el-button
                type="text"
                icon="el-icon-plus"
                @click.stop="addServiceResource"
                v-if="
                  tenantId == '4363416483534256239' && ServiceResource.relatedData.length > 0
                    ? false
                    : true
                "
              >
                添加{{ typeName }}资源
              </el-button>
            </template>
            <div class="card-group">
              <div class="c-blue c-m-b-10">
                <i class="el-icon-info c-m-r-10"></i>
                <span>可拖拽{{ typeName }}资源，调整优先分单顺序。</span>
              </div>
              <draggable v-model="ServiceResource.relatedData" @end="dragEnd">
                <transition-group>
                  <div class="card-item" v-for="(item, i) of ServiceResource.relatedData" :key="i">
                    <div class="c-m-r-10">
                      {{ i + 1 + '.' }}
                    </div>
                    <div>
                      <p>资源名称：{{ item.name }}</p>
                      <p>资源类型：{{ formatResourceType(item.resourceType) }}</p>
                      <p>当前位置：{{ item.lastKnownLocation }}</p>
                    </div>
                    <i
                      class="el-icon-close card-item-icon-remove"
                      @click="removeServiceResources(item)"
                    ></i>
                    <i
                      class="el-icon-edit card-item-icon-edit"
                      @click="editServiceResources(item)"
                    ></i>
                  </div>
                </transition-group>
              </draggable>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>

    <el-drawer
      custom-class="c-drawer"
      :title="`${typeName}资源`"
      :visible.sync="ServiceResource.openRelate"
      direction="rtl"
      :fetch-suggestions="querySearch"
    >
      <div class="el-drawer__content">
        <el-tabs v-model="ServiceResource.activeName" type="card">
          <el-tab-pane :label="`选择已有${typeName}资源`" name="search">
            <p class="c-m-b-10 c-font-13">请输入名称进行搜索</p>
            <el-select
              v-model="formData.relatedIds"
              filterable
              remote
              reserve-keyword
              :multiple="tenantId == '4363416483534256239' ? false : true"
              placeholder
              suffix-icon="el-icon-date"
              :remote-method="getServiceResource"
              clearable
              @clear="getServiceResource"
              :loading="false"
              @change="$forceUpdate()"
              class="c-w-1"
            >
              <!-- <el-option-group v-for="group in chooseArr" :key="group.label" :label="group.label">
              </el-option-group>-->
              <el-option
                v-for="(item, index) in ServiceResource.data"
                :key="item._id + index"
                :label="item.name"
                :value="item._id"
              ></el-option>
            </el-select>
          </el-tab-pane>
          <el-tab-pane :label="`新建${typeName}资源`" name="create">
            <el-form
              :model="ServiceResource.formData"
              :rules="rules"
              label-width="110px"
              label-position="left"
              hide-required-asterisk:true
            >
              <el-form-item label="名称" prop="name">
                <el-input v-model="ServiceResource.formData.name"></el-input>
              </el-form-item>
              <el-form-item label="描述" prop="description">
                <el-input type="textarea" v-model="ServiceResource.formData.description"></el-input>
              </el-form-item>
              <el-form-item label="资源类型" prop="resourceType">
                <el-select
                  v-model="ServiceResource.formData.resourceType"
                  clearable
                  @change="resourceTypeChange"
                >
                  <el-option
                    v-for="item in options.resourceType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    :disabled="
                      tenantId == '1340835581184723420'
                        ? item.value == 'partner'
                          ? false
                          : true
                        : false
                    "
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="选择资源"
                prop="serviceCrewId"
                v-if="
                  ServiceResource.formData.resourceType == 'serviceCrew' ||
                    ServiceResource.formData.resourceType == 'partner'
                "
              >
                <el-select
                  v-model="ServiceResource.formData.serviceCrewId"
                  filterable
                  remote
                  :remote-method="getOrg"
                  clearable
                  @clear="getOrg"
                  @change="$forceUpdate()"
                  placeholder="支持姓名搜索"
                >
                  <el-option
                    v-for="item in options.org"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="选择资源" prop="relatedRecordId" v-else>
                <el-select
                  v-model="ServiceResource.formData.relatedRecordId"
                  filterable
                  remote
                  :remote-method="getUser"
                  clearable
                  @clear="getUser"
                  @change="$forceUpdate()"
                  placeholder="支持姓名搜索"
                >
                  <el-option
                    v-for="item in options.user"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="位置">
                <el-input
                  type="textarea"
                  v-model="ServiceResource.formData.lastKnownLocation"
                  :disabled="
                    ServiceResource.formData.resourceType != 'serviceCrew' &&
                      ServiceResource.formData.resourceType != 'partner'
                  "
                  @change="getGeocode"
                ></el-input>
              </el-form-item>
              <el-form-item label="位置更新时间" v-show="false">
                <el-input
                  v-model="ServiceResource.formData.lastKnownLocationDate"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item
                v-for="(extField, idx) in extFields"
                :key="idx"
                :label="extField.nameDisp"
              >
                <template
                  v-if="
                    extField.type == 'text' ||
                      extField.type == 'textarea' ||
                      extField.type == 'number'
                  "
                >
                  <el-input
                    v-model="ServiceResource.formData.exts[extField.name]"
                    :type="extField.type"
                  ></el-input>
                </template>
                <template v-if="extField.type == 'radio'">
                  <el-radio-group v-model="ServiceResource.formData.exts[extField.name]">
                    <el-radio
                      v-for="item in options[extField.valueOption]"
                      :key="item.value"
                      :label="item.value"
                    >
                      {{ item.label }}
                    </el-radio>
                  </el-radio-group>
                </template>
                <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
                  <el-checkbox-group
                    v-model="ServiceResource.formData.exts[extField.name]"
                    @change="$forceUpdate()"
                  >
                    <el-checkbox
                      v-for="item in options[extField.valueOption]"
                      :label="item.value"
                      :key="item.value"
                    >
                      {{ item.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                </template>
                <template v-if="extField.type == 'select'">
                  <el-select
                    v-model="ServiceResource.formData.exts[extField.name]"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option
                      v-for="item in options[extField.valueOption]"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
                <template v-if="extField.type == 'time'">
                  <el-time-select
                    v-model="ServiceResource.formData.exts[extField.name]"
                    placeholder="选择时间"
                  ></el-time-select>
                </template>
                <template v-if="extField.type == 'date' || extField.type == 'datetime'">
                  <el-date-picker
                    v-model="ServiceResource.formData.exts[extField.name]"
                    :type="extField.type"
                    placeholder="选择日期"
                  ></el-date-picker>
                </template>
                <template v-if="extField.type == 'switch'">
                  <el-switch
                    v-model="ServiceResource.formData.exts[extField.name]"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-value="1"
                    inactive-value="0"
                  ></el-switch>
                </template>
                <template v-if="extField.type == 'rate'">
                  <el-rate
                    v-model="ServiceResource.formData.exts[extField.name]"
                    @change="$forceUpdate()"
                  ></el-rate>
                </template>
              </el-form-item>
              <el-form-item
                v-for="(extField, idx) in extFields"
                :key="idx"
                :label="extField.nameDisp"
              >
                <template
                  v-if="
                    extField.type == 'text' ||
                      extField.type == 'textarea' ||
                      extField.type == 'number'
                  "
                >
                  <el-input
                    v-model="ServiceResource.formData.exts[extField.name]"
                    :type="extField.type"
                  ></el-input>
                </template>
                <template v-if="extField.type == 'radio'">
                  <el-radio-group v-model="ServiceResource.formData.exts[extField.name]">
                    <el-radio
                      v-for="item in options[extField.valueOption]"
                      :key="item.value"
                      :label="item.value"
                    >
                      {{ item.label }}
                    </el-radio>
                  </el-radio-group>
                </template>
                <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
                  <el-checkbox-group
                    v-model="ServiceResource.formData.exts[extField.name]"
                    @change="$forceUpdate()"
                  >
                    <el-checkbox
                      v-for="item in options[extField.valueOption]"
                      :label="item.value"
                      :key="item.value"
                    >
                      {{ item.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                </template>
                <template v-if="extField.type == 'select'">
                  <el-select
                    v-model="ServiceResource.formData.exts[extField.name]"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option
                      v-for="item in options[extField.valueOption]"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
                <template v-if="extField.type == 'time'">
                  <el-time-select
                    v-model="ServiceResource.formData.exts[extField.name]"
                    placeholder="选择时间"
                  ></el-time-select>
                </template>
                <template v-if="extField.type == 'date' || extField.type == 'datetime'">
                  <el-date-picker
                    v-model="ServiceResource.formData.exts[extField.name]"
                    :type="extField.type"
                    placeholder="选择日期"
                  ></el-date-picker>
                </template>
                <template v-if="extField.type == 'switch'">
                  <el-switch
                    v-model="ServiceResource.formData.exts[extField.name]"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-value="1"
                    inactive-value="0"
                  ></el-switch>
                </template>
                <template v-if="extField.type == 'rate'">
                  <el-rate
                    v-model="ServiceResource.formData.exts[extField.name]"
                    @change="$forceUpdate()"
                  ></el-rate>
                </template>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="el-drawer__footer" v-if="ServiceResource.activeName == 'search'">
        <el-button
          type="primary"
          @click="
            doSave();
            initServiceResource();
          "
        >
          保存
        </el-button>
        <el-button
          plain
          @click="
            getData();
            initServiceResource();
          "
        >
          取消
        </el-button>
      </div>
      <div class="el-drawer__footer" v-if="ServiceResource.activeName == 'create'">
        <el-button type="primary" @click="doSaveServiceResource()">保存</el-button>
        <el-button plain @click="initServiceResource">取消</el-button>
      </div>
    </el-drawer>

    <el-drawer
      custom-class="c-drawer"
      :title="`编辑${typeName}资源`"
      :visible.sync="ServiceResource.openEdit"
      direction="rtl"
      :before-close="initServiceResource"
    >
      <div class="el-drawer__content">
        <el-form
          :model="ServiceResource.formData"
          :rules="rules"
          label-width="110px"
          label-position="left"
          hide-required-asterisk:true
        >
          <el-form-item label="名称" prop="name">
            <el-input v-model="ServiceResource.formData.name"></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="description">
            <el-input type="textarea" v-model="ServiceResource.formData.description"></el-input>
          </el-form-item>
          <el-form-item label="资源类型" prop="resourceType">
            <el-select
              v-model="ServiceResource.formData.resourceType"
              clearable
              @change="resourceTypeChange"
            >
              <el-option
                v-for="item in options.resourceType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="选择资源"
            prop="serviceCrewId"
            v-if="
              ServiceResource.formData.resourceType == 'serviceCrew' ||
                ServiceResource.formData.resourceType == 'partner'
            "
          >
            <el-select
              v-model="ServiceResource.formData.serviceCrewId"
              filterable
              remote
              :remote-method="getOrg"
              clearable
              @clear="getOrg"
              @change="$forceUpdate()"
              placeholder="支持姓名搜索"
            >
              <el-option
                v-for="item in options.org"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择资源" prop="relatedRecordId" v-else>
            <el-select
              v-model="ServiceResource.formData.relatedRecordId"
              filterable
              remote
              :remote-method="getUser"
              clearable
              @clear="getUser"
              @change="$forceUpdate()"
              placeholder="支持姓名搜索"
            >
              <el-option
                v-for="item in options.user"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="位置">
            <el-input
              type="textarea"
              v-model="ServiceResource.formData.lastKnownLocation"
              :disabled="
                ServiceResource.formData.resourceType != 'serviceCrew' &&
                  ServiceResource.formData.resourceType != 'partner'
              "
              @change="getGeocode"
            ></el-input>
          </el-form-item>
          <el-form-item label="位置更新时间" v-show="false">
            <el-input v-model="ServiceResource.formData.lastKnownLocationDate" disabled></el-input>
          </el-form-item>
          <el-form-item v-for="(extField, idx) in extFields" :key="idx" :label="extField.nameDisp">
            <template
              v-if="
                extField.type == 'text' || extField.type == 'textarea' || extField.type == 'number'
              "
            >
              <el-input
                v-model="ServiceResource.formData.exts[extField.name]"
                :type="extField.type"
              ></el-input>
            </template>
            <template v-if="extField.type == 'radio'">
              <el-radio-group v-model="ServiceResource.formData.exts[extField.name]">
                <el-radio
                  v-for="item in options[extField.valueOption]"
                  :key="item.value"
                  :label="item.value"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </template>
            <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
              <el-checkbox-group
                v-model="ServiceResource.formData.exts[extField.name]"
                @change="$forceUpdate()"
              >
                <el-checkbox
                  v-for="item in options[extField.valueOption]"
                  :label="item.value"
                  :key="item.value"
                >
                  {{ item.label }}
                </el-checkbox>
              </el-checkbox-group>
            </template>
            <template v-if="extField.type == 'select'">
              <el-select
                v-model="ServiceResource.formData.exts[extField.name]"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in options[extField.valueOption]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
            <template v-if="extField.type == 'time'">
              <el-time-select
                v-model="ServiceResource.formData.exts[extField.name]"
                placeholder="选择时间"
              ></el-time-select>
            </template>
            <template v-if="extField.type == 'date' || extField.type == 'datetime'">
              <el-date-picker
                v-model="ServiceResource.formData.exts[extField.name]"
                :type="extField.type"
                placeholder="选择日期"
              ></el-date-picker>
            </template>
            <template v-if="extField.type == 'switch'">
              <el-switch
                v-model="ServiceResource.formData.exts[extField.name]"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-value="1"
                inactive-value="0"
              ></el-switch>
            </template>
            <template v-if="extField.type == 'rate'">
              <el-rate
                v-model="ServiceResource.formData.exts[extField.name]"
                @change="$forceUpdate()"
              ></el-rate>
            </template>
          </el-form-item>
          <el-form-item v-for="(extField, idx) in extFields" :key="idx" :label="extField.nameDisp">
            <template
              v-if="
                extField.type == 'text' || extField.type == 'textarea' || extField.type == 'number'
              "
            >
              <el-input
                v-model="ServiceResource.formData.exts[extField.name]"
                :type="extField.type"
              ></el-input>
            </template>
            <template v-if="extField.type == 'radio'">
              <el-radio-group v-model="ServiceResource.formData.exts[extField.name]">
                <el-radio
                  v-for="item in options[extField.valueOption]"
                  :key="item.value"
                  :label="item.value"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </template>
            <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
              <el-checkbox-group
                v-model="ServiceResource.formData.exts[extField.name]"
                @change="$forceUpdate()"
              >
                <el-checkbox
                  v-for="item in options[extField.valueOption]"
                  :label="item.value"
                  :key="item.value"
                >
                  {{ item.label }}
                </el-checkbox>
              </el-checkbox-group>
            </template>
            <template v-if="extField.type == 'select'">
              <el-select
                v-model="ServiceResource.formData.exts[extField.name]"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in options[extField.valueOption]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
            <template v-if="extField.type == 'time'">
              <el-time-select
                v-model="ServiceResource.formData.exts[extField.name]"
                placeholder="选择时间"
              ></el-time-select>
            </template>
            <template v-if="extField.type == 'date' || extField.type == 'datetime'">
              <el-date-picker
                v-model="ServiceResource.formData.exts[extField.name]"
                :type="extField.type"
                placeholder="选择日期"
              ></el-date-picker>
            </template>
            <template v-if="extField.type == 'switch'">
              <el-switch
                v-model="ServiceResource.formData.exts[extField.name]"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-value="1"
                inactive-value="0"
              ></el-switch>
            </template>
            <template v-if="extField.type == 'rate'">
              <el-rate
                v-model="ServiceResource.formData.exts[extField.name]"
                @change="$forceUpdate()"
              ></el-rate>
            </template>
          </el-form-item>
        </el-form>
      </div>
      <div class="el-drawer__footer">
        <el-button
          type="primary"
          @click="
            doSaveServiceResource();
            initServiceResource();
          "
        >
          保存
        </el-button>
        <el-button plain @click="initServiceResource()">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
import draggable from 'vuedraggable';
export default {
  components: {
    draggable,
    bizStackTrace: () => import('../../components/bizStackTrace')
  },
  name: 'serviceTerritory',
  data() {
    window.$this = this;
    let that = this;
    return {
      savedStreet: '', //row中已保存的街道
      // gitSame: [], //相同数据
      gitDiff: [], // 不同数据
      doSaveDisableArr: [], //编辑确定后勾选中的街道
      notdDisableArr: [], //编辑时街道数据
      id: null,
      tenantId: '',
      typeName: '服务',
      collapse: false,
      formData: { exts: {}, foundTime: '' },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      fieldsObj: {},
      fpi: {},
      options: {
        codecfg_resourceType: { codeId: 'resourceType' },
        codecfg_serviceType: { codeId: 'serviceType' }
      },
      rules: this.$util.rules,
      activeTab: 'log',
      // 日志
      log: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      historyFpi: {
        page: 1,
        rows: 0,
        data: [],
        busy: false
      },
      noteData: [],
      openNote: false,
      vqeditor: this.$util.vqeditor,
      //地址级联
      area: {
        options: this.osg.areaList,
        show: true,
        props: {
          multiple: true,
          lazy: that.tenantId == '4363416483534256239' ? false : true,
          async lazyLoad(node, resolve) {
            const { level } = node;
            var nodes = [];
            if (level == '3') {
              node.data.leaf = false;
              if (node.children && node.children.length == 0) {
                node.children = [];
                let id = node.data.value;
                await that.getDataAllStreet();
                let arr = that.subdistrictT.concat(that.doSaveDisableArr, that.gitDiff);
                nodes = await that.$util.getSubdistrict(id, arr, that.savedStreet);
                if (nodes.length == 0) {
                  node.data.leaf = true;
                }
              }
            }
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }
        }
      },
      //服务资源
      ServiceResource: {
        relatedData: [],
        openEdit: false,
        openRelate: false,
        formData: { exts: {} },
        searchObj: {},
        activeName: 'search'
      },
      activeNames: ['1'],
      subdistrictT: [] //数据中的街道
      // chooseArr: []
    };
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  beforeCreate() {
    this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
  },
  beforeDestroy() {
    this.editor = null;
    delete this.editor;
  },
  mounted() {
    window.$this = this;
    this.id = this.osg.param('id');
    this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
    // TODO:仕高玛销售区域
    if (this.tenantId == '4363416483534256239') this.typeName = '销售';
    this.osg.getFields('serviceTerritory', () => {
      this.getData();
    });
    this.getLog();
    this.getNote();
  },
  methods: {
    // 请求全部数据中已保存的街道，用于判断街道去重
    getDataAllStreet() {
      return new Promise(resolve => {
        var params = {
          _all: '1',
          'in:state|array-integer#and': '0,1',
          'regex:name|string#or': this.searchValue,
          sortField: 'createTime',
          sortOrder: 'desc'
        };
        if (this.tenantId == '1340835581184723420') {
          params['is:serviceType|string#and'] = this.formData.serviceType;
        }
        //添加过滤器参数
        // this.getParams(params);
        this.osg.setFpi(params);
        this.osg.ajax('basic/serviceTerritory/query.do', params, res => {
          res.data.map(item => {
            this.subdistrictT = this.subdistrictT.concat(...item.subdistrict);
            // console.log('subdistrictT-----', this.subdistrictT);
          });

          // this.$nextTick(() => {
          //   this.$refs.table.doLayout();
          //   this.$forceUpdate();
          // });
          resolve(res.data);
        });
      });
    },
    getData() {
      return new Promise(resolve => {
        this.osg.ajax(`basic/serviceTerritory/queryById/${this.id}.do`, {}, res => {
          let row = res;
          this.$util.renderExtField(this.extFields, row);
          if (this.$util.isJson(row.area)) {
            row.area = JSON.parse(row.area);
          }

          // 往区插入下级街道数据
          let districts = [];
          let addDistricts = [];
          row.area.map(area => {
            if (area.length == 4 && districts.indexOf(area[2]) == -1) {
              districts.push(area[2]);
              addDistricts.push(area);
            }
          });

          if (districts.length > 0) {
            this.getSubdistricts(districts, subdistricts => {
              this.addSubdistricts(addDistricts, subdistricts, row);
              this.area.show = false;
              this.formData = row;
              this.initRender(); //初始化渲染
              this.$nextTick(() => {
                this.area.show = true;
              });
            });
          } else {
            this.area.show = false;
            this.formData = row;
            this.initRender(); //初始化渲染
            this.$nextTick(() => {
              this.area.show = true;
            });
          }

          resolve();
        });
      });
    },
    //初始化渲染
    initRender() {
      //获取属性修改记录
      this.getHistory();
      Promise.all([
        this.getServiceResource(null, this.formData.relatedIds && this.formData.relatedIds.join()),
        this.getOrg(),
        this.getUser()
      ]);
    },
    getSubdistricts(districts, callback) {
      this.osg.ajax(
        'area/query.do',
        {
          _all: '1',
          notFilterOrgId: '1',
          notFilterTenantId: '1',
          'in:parentCode|array#and': districts.join(),
          level: '4',
          sortField: 'code',
          sortOrder: 'asc'
        },
        res => {
          res.data.map(item => {
            item.value = item.code;
            item.label = item.name;
            item.leaf = true;
          });
          if (callback) {
            callback(res.data);
          }
        },
        {
          noload: true
        }
      );
    },
    addSubdistricts(areaList, subdistricts, row) {
      this.notdDisableArr = row.area.map((item, index) => row.area[index][3]);
      // console.log(this.notdDisableArr, '------notdDisableArr编辑前数据');
      areaList.map(area => {
        for (let i = 0; i < this.osg.areaList.length; i++) {
          let province = this.osg.areaList[i];
          if (province.value == area[0]) {
            for (let j = 0; j < province.children.length; j++) {
              let city = province.children[j];
              if (city.value == area[1]) {
                for (let k = 0; k < city.children.length; k++) {
                  let district = city.children[k];
                  if (district.value == area[2]) {
                    district.children = [];
                    district.leaf = false;
                    subdistricts.map(subdistrict => {
                      subdistrict.disabled =
                        !this.gitDiff.includes(subdistrict.value) &&
                        !this.notdDisableArr.includes(subdistrict.value) &&
                        this.subdistrictT.indexOf(subdistrict.value) !== -1;
                      this.savedStreet = row.subdistrict;
                      if (subdistrict.parentCode == district.value) {
                        district.children.push(subdistrict);
                      }
                    });
                    break;
                  }
                }
                break;
              }
            }
            break;
          }
        }
      });
    },
    //服务资源
    getServiceResource(query, ids) {
      let params = {
        page: 1,
        'in:state|array-integer#and': '0,1',
        'regex:name|string#or': query,
        sortField: 'createTime',
        sortOrder: 'desc',
        _all: '1'
      };
      // if (ids) params["in:_id|array#and"] = ids;
      // TODO:dzm、闭水租户服务区域只关联伙伴类型的服务资源
      if (this.tenantId == '1340835581184723420' || this.tenantId == '4551453470943235290') {
        params['is:resourceType|string#and'] = 'partner';
        params['is:serviceType|string#and'] = this.formData.serviceType; //服务类型
      }
      // TODO:仕高玛只关联销售人员
      if (this.tenantId == '4363416483534256239') {
        params['all:resourceRoles|array#and'] = '902552110997027850';
      }
      return new Promise(resolve => {
        this.osg.ajax(
          'biz/serviceResource/query.do',
          params,
          res => {
            if (res.data) {
              let list = [];
              this.formData.relatedIds = this.formData.relatedIds || [];
              for (let id of this.formData.relatedIds) {
                for (let item of res.data) {
                  if (id == item._id) {
                    list.push(item);
                  }
                }
              }
              this.ServiceResource.relatedData = list;
              this.ServiceResource.data = res.data;
              this.$forceUpdate();
              resolve();
            }
          },
          {
            noload: true
          }
        );
      });
    },
    doSave() {
      if (this.osg.validate()) {
        let params = this.$util.deepCopy(this.formData);

        //省市区支持多选
        params.area = params.area || [];
        let province = [];
        let city = [];
        let district = [];
        let subdistrict = [];
        for (let item of params.area) {
          if (province.indexOf(item[0]) == -1) province.push(item[0]);
          if (city.indexOf(item[1]) == -1) city.push(item[1]);
          if (district.indexOf(item[2]) == -1) district.push(item[2]);
          if (subdistrict.indexOf(item[3]) == -1) subdistrict.push(item[3]);
        }
        params.province = province;
        params.city = city;
        params.district = district;
        params.subdistrict = subdistrict;
        params.area = JSON.stringify(params.area);

        this.$util.saveExtField(this.extFields, this.formData);
        this.osg.ajax('basic/serviceTerritory/upsert.do', params, res => {
          this.doSaveDisableArr = res.data.subdistrict;
          // console.log(this.doSaveDisableArr, '------doSaveDisableArr编辑后数据');
          // 找不同元素
          this.gitDiff = this.notdDisableArr
            .concat(this.doSaveDisableArr)
            .filter((item, index, arr) => arr.indexOf(item) === arr.lastIndexOf(item));
          // console.log(this.gitDiff, '--------gitDiff不同元素');
          this.getData().then(() => {
            this.osg.toast('保存成功！');
          });
        });
      }
    },
    getLog() {
      this.log.searchDate = this.log.searchDate || [];
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: this.id,
          smodule: 'serviceTerritory',
          _all: '1',
          'regex:title|string#or': this.log.searchValue,
          'regex:content|string#or': this.log.searchValue,
          'gte:createTime|datetime#and': this.log.searchDate[0],
          'lte:createTime|datetime#and': this.log.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.log.fpi = res;
        },
        { noload: true }
      );
    },
    getHistory() {
      // 其他getFields查询会更新掉表单的fieldsObj
      let fieldsObj = {};
      this.extFields.map(item => {
        if (item.showList && item.showList.indexOf('6') != -1) {
          item.label = item.nameDisp;
          item.value = item.name;
          fieldsObj[item.name] = item;
        }
      });
      this.fieldsObj = fieldsObj;
      this.osg.ajax(
        'biz/changeLog/query.do',
        {
          sid: this.id,
          page: this.historyFpi.page,
          rows: (this.historyFpi.rows += 10)
        },
        res => {
          if (res.data.length > 0) {
            // 不需要展示变更的字段名
            res.data = res.data.filter(item => {
              item.modifyList = item.modifyList.filter(obj => {
                return (
                  this.fieldsObj[obj.field] && this.fieldsObj[obj.field].showList.indexOf('6') != -1
                );
              });
              return item.modifyList.length > 0;
            });
            this.historyFpi = res;
          }
        },
        { noload: true }
      );
    },
    formatField(row, column, cellValue) {
      return this.osg.codelabel('fields', cellValue);
    },
    formatResourceType(cellValue) {
      //反显资源类型
      return this.osg.codelabel('resourceType', cellValue);
    },
    formatFieldValue(row, column, cellValue) {
      if (this.options[row.field]) {
        return this.osg.codelabel(row.field, cellValue);
      } else {
        return cellValue;
      }
    },
    getNote() {
      this.osg.ajax(
        'note/query.do',
        {
          sid: this.id,
          smodule: 'serviceTerritory'
        },
        res => {
          this.noteData = res || [];
        }
      );
    },
    //保存笔记
    saveNote() {
      var params = {
        //sid，smodul，content，id，isDelete(值Y) 保存传123,修改传1234,删除传12345
        sid: this.id,
        smodule: 'serviceTerritory',
        content: this.vqeditor.content
      };
      this.osg.ajax('note/upsert.do', params, res => {
        this.osg.toast('保存成功！');
        this.openNote = false;
        this.getNote();
      });
    },
    noteMdShow(note) {
      note.openNote = true;
    },
    //新增服务资源
    addServiceResource() {
      this.ServiceResource.formData = { exts: {}, gpsPoint: {} };
      this.ServiceResource.openRelate = true;
    },
    //删除服务资源
    removeServiceResource(removeResourcesId) {
      return new Promise(resolve => {
        this.osg.ajax(`biz/serviceResource/remove/${removeResourcesId}.do`, null, res => {
          resolve();
        });
      });
    },
    //保存服务资源
    doSaveServiceResource() {
      if (this.osg.validate()) {
        let params = this.$util.deepCopy(this.ServiceResource.formData);
        this.$util.saveExtField(this.extFields, params);
        //保存经纬度
        params['gpsPoint.longitude'] = params.gpsPoint && params.gpsPoint.longitude;
        params['gpsPoint.latitude'] = params.gpsPoint && params.gpsPoint.latitude;
        delete params.gpsPoint;
        params.relatedIds = this.formData._id;
        params.relatedName = this.formData.name;
        this.osg.ajax('biz/serviceResource/upsert.do', params, res => {
          this.formData.relatedIds.push(res.entity._id);
          this.doSave();
          this.initServiceResource();
          this.osg.toast('保存成功！');
        });
      }
    },
    initServiceResource() {
      this.ServiceResource.openEdit = false;
      this.ServiceResource.openRelate = false;
      this.ServiceResource.formData = { exts: {}, gpsPoint: {} };
      this.ServiceResource.formData = { exts: {}, gpsPoint: {} };
      this.$util.renderExtField(this.extFields, this.ServiceResource.formData);
    },
    //删除服务资源
    removeServiceResources(item) {
      this.osg.confirm(`删除与 "${item.name}" 的关联？`, () => {
        this.formData.relatedIds.splice(
          this.formData.relatedIds.findIndex(ele => ele == item._id),
          1
        );
        this.doSave();
      });
    },
    //编辑服务资源
    editServiceResources(item) {
      this.ServiceResource.formData = item;
      this.ServiceResource.openEdit = true;
    },
    //获取地理编码
    async getGeocode() {
      if (this.ServiceResource.formData.lastKnownLocation) {
        this.osg.geocode(this.ServiceResource.formData.lastKnownLocation, res => {
          this.ServiceResource.formData.gpsPoint = {
            longitude: res.location.split(',')[0],
            latitude: res.location.split(',')[1]
          };
          this.ServiceResource.formData.lastKnownLocationDate = new Date()
            .toLocaleString('chinese', {
              hour12: false
            })
            .replace(/\//g, '-');
          this.$forceUpdate();
        });
      }
    },
    //根据网址 提示域名下拉框
    querySearch(queryString, cb) {
      let url = this.formData.website;
      let reg = /^((https|http|ftp|rtsp|mms){0,1}(:\/\/){0,1})www\.(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/;
      if (reg.test(url)) {
        if (url.indexOf('www.') != -1) {
          url = url.substr(url.indexOf('.') + 1);
        } else if (url.indexOf('http://') != -1) {
          url = url.substr(url.indexOf('/', url.indexOf('/') + 1) + 1);
        } else if (url.indexOf('https://') != -1) {
          url = url.substr(url.indexOf('/', url.indexOf('/') + 1) + 1);
          if (url.indexOf('https://www.') != -1) {
            url = url.substr(url.indexOf('.') + 1);
          }
        }
        // 调用 callback 返回建议列表的数据
        cb([{ label: url, value: url }]);
      } else {
        cb([{}]);
      }
    },
    //修改服务资源类型
    resourceTypeChange() {
      this.ServiceResource.formData.relatedRecordId = '';
      this.ServiceResource.formData.serviceCrewId = '';
      if (
        this.ServiceResource.formData.resourceType == 'serviceCrew' ||
        this.ServiceResource.formData.resourceType == 'partner'
      ) {
        this.getOrg();
      } else {
        this.getUser();
        //服务资源是user时，位置信息置空通过定位来更新。
        this.ServiceResource.formData.gpsPoint = {};
        this.ServiceResource.formData.lastKnownLocation = '';
        this.ServiceResource.formData.lastKnownLocationDate = '';
      }
      this.$forceUpdate();
    },
    //获取用户
    getUser(query) {
      return new Promise(resolve => {
        let params = {
          page: 1,
          rows: 20,
          tenantId: this.tenantId,
          'regex:name|string#and': query
          // "exists:serviceResourceId|boolean#or": false,
          // "is:serviceResourceId|string#or": this.formData._id
        };
        this.osg.ajax(
          'user/query.do',
          params,
          res => {
            res.data.map(item => {
              item.label = item.name;
              item.value = item._id;
            });
            this.options.user = res.data;
            this.$forceUpdate();
            resolve();
          },
          { noload: true }
        );
      });
    },
    //获取组织
    getOrg(query) {
      return new Promise(resolve => {
        this.osg.ajax(
          'org/query.do',
          {
            orgType: this.ServiceResource.formData.resourceType,
            'regex:orgName|string#and': query,
            'exists:serviceResourceId|boolean#or': false,
            'is:serviceResourceId|string#or': this.formData._id
          },
          res => {
            res.data.orgList.map(item => {
              item.label = item.orgName;
              item.value = item._id;
            });
            this.options.org = res.data.orgList;
            this.$forceUpdate();
            resolve();
          },
          { noload: true }
        );
      });
    },
    dragEnd() {
      let relatedIds = [];
      for (let item of this.ServiceResource.relatedData) {
        relatedIds.push(item._id);
      }
      this.formData.relatedIds = relatedIds;
      this.doSave();
    }
  }
};
</script>
<style lang="scss" scoped>
/*个人信息*/
.box-left-header-contact {
  border-bottom: 1px solid #dfe3eb;
}
.profile-info {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.profile-info > * {
  margin: 10px auto;
}
.profile-info > span {
  margin: 0;
  font-weight: 400;
  font-size: 24px;
}
.profile-info ul {
  display: flex;
}
.profile-info ul li {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 5px;
}
.profile-info ul li span {
  margin-top: 8px;
  font-size: 12px;
}
/* 快捷按钮 */
.shortcuts button {
  background-color: #eaf0f6;
  border-color: #cbd6e2;
  color: #506e91;
}
.shortcuts button i {
  font-weight: bold;
}
.card-item {
  background: #fff;
}
</style>
